'use client';
'use client';

import { c as _c } from "react/compiler-runtime";
import { BuilderBlocks } from '@builder.io/react';
import { CheckIcon, MinusIcon, XMarkIcon } from '@heroicons/react/24/outline';
import { Container } from '@src/components/Container/Container';
import { FeaturedChartDefaults } from '@src/components/FeaturedChart/FeaturedChart.defaults';
import { type FeaturedChartProps, type FeaturedChartRow } from '@src/components/FeaturedChart/FeaturedChart.props';
import { cn } from '@src/utils/tailwind';
export const FeaturedChart = t0 => {
  const $ = _c(20);
  const props = t0 === undefined ? FeaturedChartDefaults : t0;
  const {
    builderBlock,
    rows,
    heading,
    rowHeadings,
    featuredColumnHeader,
    blocksBottom
  } = props;
  let t1;
  if ($[0] !== featuredColumnHeader || $[1] !== rowHeadings) {
    t1 = t2 => {
      const {
        onlyTwoColumns
      } = t2;
      return <tr className="h-[45px] lg:h-auto"><th className={cn("w-(--col-1-width)", {
          "invisible lg:visible": !onlyTwoColumns
        })} /><th className={cn("relative z-10 w-(--col-2-width) text-center font-medium", {
          "invisible lg:visible": !onlyTwoColumns
        })}>{featuredColumnHeader}</th>{rowHeadings?.map(header => <th className={cn("w-(--col-3-width) text-center text-body-xs font-normal text-bodi-gray-disabled", {
          "hidden lg:block": onlyTwoColumns
        })} key={header.text} dangerouslySetInnerHTML={{
          __html: header.text ?? ""
        }} />)}</tr>;
    };
    $[0] = featuredColumnHeader;
    $[1] = rowHeadings;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const renderHeader = t1;
  let t2;
  if ($[3] !== builderBlock?.id) {
    t2 = args => {
      const {
        i,
        row,
        onlyTwoColumns: onlyTwoColumns_0
      } = args;
      return <tr key={i} className="group relative bg-bodi-black-text odd:bg-[#1d1f20]"><td className={cn("p-4 text-bodi-white first:rounded-l-2xl", {
          "invisible lg:visible": !onlyTwoColumns_0
        })}><BuilderBlocks parentElementId={builderBlock?.id} dataPath={`component.rows.${i}`} blocks={row.blocks} /></td><td className={cn("relative z-10 p-0", {
          "invisible lg:visible": !onlyTwoColumns_0
        })}><div className="mx-auto flex size-8 items-center justify-center rounded-full bg-bodi-white text-bodi-black-text"><CheckIcon className="size-5 stroke-[2.5px]" /></div><div className="absolute bottom-0 left-0 h-px w-full bg-bodi-gray-dark/25 group-last-of-type:hidden" /></td>{row.content.map((t3, i_0) => {
          const {
            icon
          } = t3;
          const iconMap = {
            checkmark: CheckIcon,
            dash: MinusIcon,
            x: XMarkIcon
          };
          const Icon = iconMap[icon];
          return <td key={i_0} className={cn("border-r border-bodi-gray-dark/50 p-0 last:rounded-r-2xl last:border-0 lg:w-auto", {
            "hidden lg:block": onlyTwoColumns_0
          })}><div className={cn("mx-auto flex size-8 items-center justify-center rounded-full", {
              "bg-bodi-accent-deep-500": icon === "checkmark"
            })}><Icon className={cn("size-7 stroke-[2.5px] text-bodi-gray-medium", {
                "text-bodi-white size-5": icon === "checkmark"
              })} /></div></td>;
        })}</tr>;
    };
    $[3] = builderBlock?.id;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const renderRow = t2;
  let t3;
  if ($[5] !== renderHeader || $[6] !== renderRow || $[7] !== rows) {
    t3 = () => <div className={cn("relative -mr-4 mb-8 lg:mr-0", "[--col-1-width:146px] lg:[--col-1-width:377px]", "[--col-2-width:107px] lg:[--col-2-width:142px]", "[--col-3-width:94px] lg:[--col-3-width:auto]")}><div className="relative overflow-x-scroll lg:overflow-x-auto"><table className="table-fixed w-fit lg:w-full"><thead>{renderHeader({
              onlyTwoColumns: false
            })}</thead><tbody>{rows?.map((row_0, i_1) => renderRow({
              row: row_0,
              i: i_1,
              onlyTwoColumns: false
            }))}</tbody></table></div><table className={cn("table-fixed w-fit lg:w-full", "absolute top-0 left-0 bg-bodi-black-text lg:hidden lg:table-auto")}><thead>{renderHeader({
            onlyTwoColumns: true
          })}</thead><tbody>{rows?.map((row_1, i_2) => renderRow({
            row: row_1,
            i: i_2,
            onlyTwoColumns: true
          }))}</tbody></table><div className="absolute top-0 left-(--col-1-width) h-full w-(--col-2-width) rounded-2xl bg-linear-to-b from-bodi-accent-bright-500 to-bodi-accent-deep-500" /></div>;
    $[5] = renderHeader;
    $[6] = renderRow;
    $[7] = rows;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const renderTable = t3;
  let t4;
  if ($[9] !== heading) {
    t4 = <h2 className="text-heading-display-2 mb-8 text-center text-bodi-gray-pearl">{heading}</h2>;
    $[9] = heading;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== renderTable) {
    t5 = renderTable();
    $[11] = renderTable;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  const t6 = builderBlock?.id;
  let t7;
  if ($[13] !== blocksBottom || $[14] !== t6) {
    t7 = <BuilderBlocks parentElementId={t6} dataPath="component.blockBottom" blocks={blocksBottom} />;
    $[13] = blocksBottom;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t4 || $[17] !== t5 || $[18] !== t7) {
    t8 = <div className="bg-bodi-black-text py-12 lg:py-16"><Container>{t4}{t5}{t7}</Container></div>;
    $[16] = t4;
    $[17] = t5;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  return t8;
};